import { memo, useState } from "react"
import { CameraName, IconPlay, IconSize, GridCameraName } from "./sxVisualizacaoEvento"
import { DownloadForOffline, PhotoCamera, PlayCircleFilled } from "@mui/icons-material"
import { Box, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import ModalFoto from "../ModalFoto/ModalFoto"

const LineFotoPlay = ({ title, imageName, eventId }) => {
    const [openFoto, setOpenFoto] = useState(false)

    return (
        <Grid xs={12} container >
            {openFoto && <ModalFoto open={openFoto} setOpen={setOpenFoto} imageName={imageName} eventId={eventId} />}
            <Grid xs={9} sx={GridCameraName}>
                <Box component='div'><PhotoCamera sx={IconSize}/></Box>
                <Box component='div' sx={{ ...CameraName, maxWidth: '100%' }}>{title}</Box>
            </Grid>
            <Grid xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', maxHeight: '20px' }}>
                <Tooltip title={'Em Breve'} placement="left" arrow>
                    <Box component='div' sx={IconPlay}><DownloadForOffline sx={IconSize}/></Box>
                </Tooltip>
                <Tooltip title={'Visualizar'} placement="left" arrow>
                    <Grid onClick={() => setOpenFoto(true)}>
                        <Box component='div'sx={IconPlay}><PlayCircleFilled sx={IconSize}/> </Box>
                    </Grid>
                </Tooltip>
            </Grid>
        </Grid>
    )
}

export default memo(LineFotoPlay)
